import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"
import Button from "shared/components/Button/Button"

import styles from "./PlansListingSwitch.module.css"

const PlansListingSwitch = ({ isDomestic }) => {
  const { t: translate } = useTranslate()
  return (
    <div className="flex-container f-j-center m-t-50">
      <div className="flex-container f-a-center">
        <div className={[!isDomestic && styles.selected, styles.tab].join(" ")}>
          <Button
            variation="textLink"
            className="fs-18 w-500"
            to="/plans/monthly"
          >
            {translate("Webinterpret listings")}
          </Button>
        </div>
        <div className={[isDomestic && styles.selected, styles.tab].join(" ")}>
          <Button
            variation="textLink"
            className="fs-18 w-500"
            to="/plans/domestic"
          >
            {translate("Your domestic listings")}
          </Button>
        </div>
      </div>
    </div>
  )
}

PlansListingSwitch.propTypes = {
  isDomestic: PropTypes.bool.isRequired,
}

export default PlansListingSwitch
